// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { SUPABASE_AUTH_OPTIONS } from './auth-config';

// Strip ANY invisible/whitespace/non-ASCII character from these build-time env
// values — not just the ends. A value pasted into a CI env-var UI (Xcode Cloud)
// can pick up a newline in the MIDDLE when the field wraps a long key, and
// `.trim()` (ends only) doesn't catch that. Even one such char in the anon key
// or URL makes an invalid HTTP `apikey`/`Authorization` header (or malformed
// URL), and WebKit (iOS WKWebView) throws a bare `TypeError` ("Type error") the
// instant the request is built — before it hits the network (so nothing shows
// in the Network tab and no JS error is logged), while web (built from a clean
// env source) works. Confirmed via an on-device simulator diagnostic: with a
// clean env the exact same native code signs in normally. A valid Supabase URL
// and anon-key JWT are pure printable ASCII, so keeping only 0x21–0x7e is
// lossless here and makes the client immune to a corrupted build env.
const cleanEnv = (v: string | undefined) => v?.replace(/[^\x21-\x7e]/g, '');
const SUPABASE_URL = cleanEnv(import.meta.env.VITE_SUPABASE_URL);
const SUPABASE_PUBLISHABLE_KEY = cleanEnv(import.meta.env.VITE_SUPABASE_ANON_KEY);

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// NOTE: the generated-file banner above is stale — this file is hand-maintained
// (custom auth storage, realtime tuning). Auth options live in ./auth-config so
// the lockAcquireTimeout override is unit-testable; keep them there. If you ever
// regenerate this file, re-apply the `auth: SUPABASE_AUTH_OPTIONS` wiring.
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: SUPABASE_AUTH_OPTIONS,
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});